import React, { useImperativeHandle, useState } from 'react'

import { useQuery } from '@tanstack/react-query'
import { CustomCellEditorProps } from 'ag-grid-react'

import { useApi } from '@fortem-monorepo/react-spa'
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  MultiSelectCreate,
} from '@fortem-monorepo/react-ui'

import { TagsRendererComponent } from '@/ag-grid/columns/tags/renderer'

type EditorRef = {
  getValue: () => string[]
}

export interface TagsCellEditorProps extends CustomCellEditorProps<{
  tags: string[]
  trade_id?: string
}> {}

export const TagsCellEditor = React.forwardRef<EditorRef, TagsCellEditorProps>(
  ({ value, onValueChange, stopEditing, data }, ref) => {
    const [open, setOpen] = useState(true)
    const [innerValue, setInnerValue] = useState(value)

    const tags = useQuery({
      queryKey: ['static', 'trade-tags'],
      queryFn: () => api.misc.getTradeTags(),
    })

    const api = useApi()

    useImperativeHandle(ref, () => ({
      getValue: () => innerValue,
    }))

    if (innerValue && Array.isArray(innerValue)) {
      return (
        <>
          <TagsRendererComponent value={value} />
          <Dialog
            open={open}
            onOpenChange={(open) => {
              if (!open) {
                stopEditing()
              }
              setOpen(open)
            }}
          >
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Update tags for trade {data?.trade_id}</DialogTitle>
                <DialogDescription></DialogDescription>
              </DialogHeader>
              <div>
                <MultiSelectCreate
                  items={tags.data ?? []}
                  value={innerValue}
                  onValueChange={(val) => {
                    setInnerValue(val)
                  }}
                />
              </div>
              <DialogFooter>
                <Button
                  variant={'destructive'}
                  onClick={() => {
                    setOpen(false)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant={'default'}
                  onClick={() => {
                    onValueChange(innerValue)
                    stopEditing()
                  }}
                >
                  Save
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </>
      )
    }
  },
)
